// HomeSkeleton.js
// Grey placeholder bars shown while a card's data is still loading.
import React from "react";
import { View, StyleSheet, Platform } from "react-native";

import { homeColors } from "../homeTheme";

const identity = (s) => s;

const HomeSkeleton = ({ rows = 1, isDarkMode = false, testID, t = identity }) => {
  const colors = homeColors(isDarkMode);
  const webBusyProp = Platform.OS === "web" ? { "aria-busy": true } : null;

  return (
    <View
      testID={testID}
      style={styles.wrap}
      accessibilityRole="progressbar"
      accessibilityLabel={t("Loading")}
      {...webBusyProp}
    >
      {Array.from({ length: rows }).map((_, i) => (
        <View
          key={i}
          style={[styles.bar, { backgroundColor: colors.border }]}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { gap: 10 },
  bar: { height: 14, borderRadius: 7 },
});

export default HomeSkeleton;
